import { Injectable } from '@angular/core';

/**
 * Imprime en consola mensajes utilizando como prefijo la fecha y hora
 */
@Injectable()
export class LoggerService {
  /**
   * Imprime en consola un mensaje
   * @param message mensaje
   * @param args otros mensaje
   */
  public static log(message: string, ...args: any[]): void {
    console.log(LoggerService.prependTime(message), args.join());
  }

  /**
   * Imprime en consola en context de información
   * @param message mensaje
   * @param args otros mensaje
   */
  public static info(message: string, ...args: any[]): void {
    console.info(LoggerService.prependTime(message), args.join());
  }

  /**
   * Imprime en consola en context de advertencia
   * @param message mensaje
   * @param args otros mensaje
   */
  public static warn(message: string, ...args: any[]): void {
    console.warn(LoggerService.prependTime(message), args.join());
  }

  /**
   * Imprime en consola en context de error
   * @param message mensaje
   * @param args otros mensaje
   */
  public static error(message: string, ...args: any[]): void {
    console.error(LoggerService.prependTime(message), args.join());
  }

  /**
   * concatena la fecha y hora al mensaje y lo retorna
   * @param message mensaje
   */
  private static prependTime(message: string): string{
    const time = new Date().toISOString();
    return `${time} - ${message}`;
  }
}
